import TourPage from "@/components/TourPage";

export default function CulturalWildlife21Day() {
  return (
    <TourPage
      tourId="uganda/cultural-wildlife-21-day"
      title="21-Day Uganda Cultural and Wildlife Safari"
      duration="21 Days / 20 Nights"
      price="Contact for price"
      image="/leopard.png"
      description="The ultimate Uganda experience combining cultural encounters with extensive wildlife viewing across all major national parks."
      itinerary={[
        {
          day: 1,
          title: "Arrival",
          description: "Begin your Uganda adventure with a warm welcome to the Pearl of Africa.",
          activities: [
            "Meet and greet with our guide at Entebbe International Airport",
            "Transfer to your hotel for an overnight stay"
          ],
          accommodation: "Hotel in Entebbe",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Entebbe – Mabamba Swamp – Jinja",
          description: "Search for the prehistoric Shoebill Stork and travel to the adventure capital of Uganda.",
          activities: [
            "Depart for Mabamba Swamp to search for the prehistoric Shoebill Stork",
            "Head to Jinja, the adventure capital of Uganda"
          ],
          accommodation: "Lodge in Jinja",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Jinja",
          description: "Experience adventurous activities and cruise on Lake Victoria.",
          activities: [
            "Go quad biking or rafting in the morning",
            "Take a boat cruise on Lake Victoria to the starting point of the Nile River"
          ],
          accommodation: "Lodge in Jinja",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Jinja – Sipi Falls",
          description: "Travel to the beautiful waterfalls of Sipi.",
          activities: [
            "Drive to Sipi Falls, with a stopover in Mbale for lunch",
            "Enjoy the scenic landscape of the Kigezi Highlands"
          ],
          accommodation: "Lodge in Sipi Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Hiking, Nature Walk, and Coffee Tour",
          description: "Explore the natural beauty and coffee culture of Sipi Falls.",
          activities: [
            "Hike to the top of the falls",
            "Take a nature walk",
            "Enjoy a coffee tour in the Sipi Falls area"
          ],
          accommodation: "Lodge in Sipi Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Sipi Falls – Moroto",
          description: "Journey through remote areas with scenic reserves.",
          activities: [
            "Drive to Moroto, passing through a remote area with scenic reserves, including Pian Upe"
          ],
          accommodation: "Lodge in Moroto",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Moroto – Kidepo Valley National Park",
          description: "Travel to one of Africa's most isolated yet spectacular wildlife refuges.",
          activities: [
            "Drive to Kidepo Valley National Park, known for its stunning landscapes and abundant wildlife"
          ],
          accommodation: "Lodge in Kidepo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Kidepo Valley National Park",
          description: "Explore the rich wildlife and unique landscapes of Kidepo.",
          activities: [
            "Take a game drive",
            "Visit the Kanangorok hot springs"
          ],
          accommodation: "Lodge in Kidepo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 9,
          title: "Kidepo Valley National Park – Murchison Falls National Park",
          description: "Journey to Uganda's largest and oldest conservation area.",
          activities: [
            "Drive to Murchison Falls National Park, passing through Gulu"
          ],
          accommodation: "Lodge in Murchison Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 10,
          title: "Game Drive and Boat Cruise",
          description: "Experience the diverse wildlife and the powerful waterfall on the Victoria Nile.",
          activities: [
            "Take a game drive",
            "Boat cruise on the Nile River"
          ],
          accommodation: "Lodge in Murchison Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 11,
          title: "Murchison Falls National Park – Kibale Forest National Park",
          description: "Travel to the primate capital of the world.",
          activities: [
            "Drive to Kibale Forest National Park, known for its chimpanzees"
          ],
          accommodation: "Lodge in Kibale",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 12,
          title: "Chimpanzee Tracking",
          description: "Come face to face with our closest relatives in their natural habitat.",
          activities: [
            "Track chimpanzees in Kibale Forest National Park"
          ],
          accommodation: "Lodge in Kibale",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 13,
          title: "Kibale Forest National Park – Semuliki National Park",
          description: "Visit a unique park known for its hot springs and lowland forest.",
          activities: [
            "Drive to Semuliki National Park, known for its hot springs"
          ],
          accommodation: "Lodge in Semuliki",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 14,
          title: "Semuliki National Park – Queen Elizabeth National Park",
          description: "Journey to Uganda's most popular wildlife reserve.",
          activities: [
            "Drive to Queen Elizabeth National Park, passing through the Kigezi Highlands"
          ],
          accommodation: "Lodge in Queen Elizabeth",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 15,
          title: "Queen Elizabeth National Park",
          description: "Explore the diverse ecosystems and abundant wildlife.",
          activities: [
            "Take a game drive",
            "Boat cruise on the Kazinga Channel"
          ],
          accommodation: "Lodge in Queen Elizabeth",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 16,
          title: "Queen Elizabeth National Park – Bwindi Impenetrable National Park",
          description: "Travel to the mountain gorilla sanctuary.",
          activities: [
            "Drive to Bwindi Impenetrable National Park, known for its mountain gorillas"
          ],
          accommodation: "Lodge in Bwindi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 17,
          title: "Gorilla Trekking",
          description: "The ultimate wildlife experience - coming face to face with endangered mountain gorillas.",
          activities: [
            "Track mountain gorillas in Bwindi Impenetrable National Park"
          ],
          accommodation: "Lodge in Bwindi",
          meals: "Breakfast, Packed Lunch, Dinner"
        },
        {
          day: 18,
          title: "Mgahinga Gorilla National Park",
          description: "Experience the culture of the indigenous forest people.",
          activities: [
            "Take the Batwa cultural trail in Mgahinga Gorilla National Park"
          ],
          accommodation: "Lodge in Mgahinga",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 19,
          title: "Mgahinga National Park – Lake Bunyonyi",
          description: "Travel to one of Africa's most beautiful lakes.",
          activities: [
            "Drive to Lake Bunyonyi and relax by the scenic lake"
          ],
          accommodation: "Lodge at Lake Bunyonyi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 20,
          title: "Lake Bunyonyi – Lake Mburo National Park",
          description: "Journey to Uganda's smallest savannah national park.",
          activities: [
            "Drive to Lake Mburo National Park",
            "Take a boat cruise on the lake"
          ],
          accommodation: "Lodge in Lake Mburo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 21,
          title: "Lake Mburo National Park – Entebbe",
          description: "Final journey back to Entebbe with cultural stops along the way.",
          activities: [
            "Drive back to Entebbe",
            "Stopover at the Equator and the Mpigi Royal Drum Makers"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "All park entrance fees and permits",
        "All activities, including chimpanzee tracking, gorilla trekking, and boat cruises",
        "All meals (breakfast, lunch, and dinner)",
        "A professional driver guide",
        "All transportation and airport transfers in a 4x4 luxury vehicle",
        "Accommodation for all nights"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "The government imposed an increase in taxes and/or park fees",
        "Tip"
      ]}
    />
  );
}
